import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * useEmployees(pharmacyCodeOverride?)
 * - default: user.pharmacyCode
 * - admin/rm review: můžeš předat targetPharmacyCode
 */
export default function useEmployees(pharmacyCodeOverride = null) {
  const { user } = useAuth();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const targetPharmacyCode = pharmacyCodeOverride || user?.pharmacyCode;

  useEffect(() => {
    if (!user || !user.firma || !targetPharmacyCode) return;

    const load = async () => {
      try {
        setLoading(true);

        const res = await fetch(
          `/api/employees/${user.firma}/${targetPharmacyCode}`,
          { credentials: "include" }
        );

        if (!res.ok) {
          console.error("Nepodařilo se načíst zaměstnance:", res.status);
          setEmployees([]);
          return;
        }

        const data = await res.json();

        const mapped = (Array.isArray(data) ? data : []).map((e) => {
          const fullFond = e.denniFond ?? 8;
          const fondR = fullFond;
          const fondO = fullFond;

          return {
            id: e._id,
            name: e.fullName,
            role:
              e.position === "farmaceut"
                ? "magistr"
                : e.position === "asistent"
                ? "assistant"
                : "sanitar",
            fondR,
            fondO,
            fullFond,
            uvazek: e.uvazek,
            active: e.active,
            isFlying: e.isFlying,
          };
        });

        setEmployees(mapped);
      } catch (err) {
        console.error("Chyba při načítání zaměstnanců:", err);
        setEmployees([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [user, targetPharmacyCode]);

  return { employees, loading };
}
